<template>
     <div>
        <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit" >
            <!-- tab 1 content -->
            <tab-content title="Create Schedule" class="mb-5" :before-change="validateStep1">
                <form data-vv-scope="step-1">
                    <vx-card>
                        <div class="vx-row" >
                            <div class="vx-col sm:w-1/2 w-full mt-5" style="font-size:20px">
                                <span  class="text-sm" ><b style="font-size:20px">Schedule Number : </b></span>
                                <b style="color:blue">{{ this.createdSchedule.createScheduleId }}</b>
                            </div>
                        </div>
                        <div class="vx-row" >
                            <div class="vx-col sm:w-1/2 w-full mt-5" style="font-size:20px">
                                <span  class="text-sm" ><b style="font-size:15px">Reference Number : </b></span>
                                <b style="color:blue">{{ this.createdSchedule.referenceNumber }}</b>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5"><span  class="text-sm">Tenant</span><span style="color:red">*</span>
                                <v-select  v-validate="'required'" name="Company Name" class="w-full"  v-model="tenant" label="name" :options="getAllTenant"  placeholder="Please Select"/>
                                <span class="text-danger text-sm" >{{ errors.first('step-1.Company Name') }}</span>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5"><span  class="text-sm">Schedule Number</span><span style="color:red">*</span>
                                <v-select  v-validate="'required'" name="Schedule Number" class="w-full"  v-model="scheduleNumber" label="scheduleNumberName" :options="getAllScheduleNumber"  placeholder="Please Select"/>
                                <span class="text-danger text-sm" >{{ errors.first('step-1.Schedule Number') }}</span>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <span  class="text-sm">Cut-Off Start Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'" name="Start Date" v-model="createdSchedule.cutOffStartDate" class="w-full" />
                                <span class="text-danger" >{{ errors.first('step-1.Start Date') }}</span>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <span  class="text-sm">Cut-Off End Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'" name="End Date" v-model="createdSchedule.cutOffEndDate" class="w-full" />
                                <span class="text-danger">{{ errors.first('step-1.End Date') }}</span>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-5 mt-5">
                                <span  class="text-sm">Remarks</span>
                                <vs-input  name="remarks" v-model="createdSchedule.remarks" class="w-full" />
                            </div>
                        </div>
                        <div class="flex justify-between flex-wrap mb-5 mt-5">
                            <span/>
                            <vs-button @click="Save()" color="primary" type="filled" icon-pack="feather" icon="icon-save"> Save</vs-button>
                        </div>

                        <div class="vx=row">
                            <vs-table  stripe v-model="selected"  max-items="4" pagination @selected="handleSelected"  search :data="getAllCreateSchedule">
                                 <template slot="thead">
                                    <vs-th sort-key="createdOn">Date Created</vs-th>
                                    <vs-th >Company Name</vs-th>
                                    <vs-th>Sched</vs-th>
                                    <vs-th sort-key="fromDate">From Date</vs-th>
                                    <vs-th>To Date</vs-th>
                                    <vs-th>Reference No.</vs-th>
                                    <vs-th>Remarks</vs-th>
                                    <vs-th>Status</vs-th>
                                    <vs-th>Closed?</vs-th>
                                    <vs-th>Actions</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td :data="data[indextr].createdOn">
                                            {{data[indextr].createdOn | fulldate}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].tenantsId">
                                            {{getTenantName(data[indextr].tenantsId).name }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].scheduleNumberId">
                                            {{ getScheduleNumberName(data[indextr].scheduleNumberId).scheduleNumberName }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].cutOffStartDate">
                                            {{data[indextr].cutOffStartDate | fulldate}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].cutOffEndDate">
                                            {{data[indextr].cutOffEndDate | fulldate}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].referenceNumber">
                                            {{data[indextr].referenceNumber}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].remarks">
                                            {{data[indextr].remarks}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].status">
                                            <vs-chip class="ag-grid-cell-chip" :color="chipColor(data[indextr].status)">
                                                <span>{{getStatusName(data[indextr].status).status}}</span>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td :data="data[indextr].isClosed">
                                            <vs-chip class="ag-grid-cell-chip" :color="chipColor(data[indextr].isClosed)">
                                                <span>{{ data[indextr].isClosed ? 'Closed' : 'Open' }}</span>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td>
                                            <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-show="!data[indextr].isClosed">
                                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].createdScheduleId)" />
                                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].createdScheduleId)" />
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>

                        </div>

                    </vx-card>
                    

                    
                </form>
            </tab-content>
            <tab-content title="Select Employees" class="mb-5" :before-change="validateStep2">
                <form data-vv-scope="step-2">
                    <select-employees :createSchedule="createdSchedule" :isValidate2="isValidate2"/>
                </form>
            </tab-content>
            <tab-content title="Verify Schedule" class="mb-5" :before-change="validateStep3">
                <form data-vv-scope="step-3">
                    <verify-schedule :createSchedule="createdSchedule" :isValidate3="isValidate3"/>
                </form>
            </tab-content>
        </form-wizard>
    <vs-prompt
        class="email-compose"
        title="Schedule Details"
        accept-text= "Ok"
        :active.sync="activePromptScheduleNumber">
        <vx-card  title="List of Schedules">
            <vs-table stripe max-items="7" pagination search  :data="getAllTenantsSchedule">
                <template slot="thead">
                    <vs-th>Day</vs-th>
                    <vs-th>Shift</vs-th>
                    <vs-th>Schedule In</vs-th>
                    <vs-th>Schedule Out</vs-th>
                    <vs-th>Work Day?</vs-th>
                    <vs-th>Hours in a day</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].daysName">
                            {{ getDayName(data[indextr].daysName).dayName }}
                        </vs-td>
                        <vs-td :data="data[indextr].shiftTypeId">
                            {{ shiftTypeName(data[indextr].shiftTypeId).shiftTypeName }}
                        </vs-td>
                        <vs-td :data="data[indextr].scheduleIN">
                            {{ data[indextr].scheduleIN }}
                        </vs-td>
                        <vs-td :data="data[indextr].scheduleOUT">
                            {{ data[indextr].scheduleOUT }}
                        </vs-td>
                        <vs-td :data="data[indextr].isRestDay">
                            <vs-chip class="ag-grid-cell-chip" :color="chipColor(data[indextr].isRestDay ? 3 : 1)">
                                <span>{{data[indextr].isRestDay ? 'No' : 'Yes' }}</span>
                            </vs-chip>
                            <!-- <vs-checkbox v-model="data[indextr].isRestDay" class="pointer-events-none" /> -->
                        </vs-td>
                        <vs-td :data="data[indextr].workedHours">
                            {{data[indextr].workedHours }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </vs-prompt>


     </div>
    
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'


import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
import axios from '@/axios.js'
import SelectEmployees from './schedule/SelectEmployees.vue'
import VerifySchedule from './schedule/VerifySchedule.vue'

export default {
    data() {
        return {
            createdSchedule : {},
            scheduleNumber: [],
            tenant: [],


            selected: [],
            isValidate2: false,
            isValidate3: false,

            activePromptScheduleNumber: false

        } 
    },
    watch: {
        scheduleNumber() {
            this.activePromptScheduleNumber = true
        }
    },
    created() {
        // if(this.$store.state.hrms.allEmployee == null) {
        this.$vs.loading()
        const payload = {
                    pageNumber: 1,
                    pageSize: -1,
                    sortBy: 'CreatedOn',
                    sortOrder: 'Desc',
        }
        this.$store.dispatch('tenants/getAllTenants', payload)
            
        // }
        this.$store.dispatch('schedule/getAllCreateSchedule').catch(err => { console.error(err) })
        this.$store.dispatch('lookup/getAllShiftType').catch(err => { console.error(err) })
        this.$store.dispatch('lookup/getAllScheduleType').catch(err => { console.error(err) })
        this.$store.dispatch('lookup/getAllScheduleNumber').catch(err => { console.error(err) })
        this.$store.dispatch('tenants/getAllTenantsSchedule', { tenantsId: this.$store.state.AppActiveUser.tenantsId}).catch((err) => { console.log(err)})
           
        const data= {
                pageNumber: 1,
                pageSize: -1
            }
        this.$store.dispatch('hrms/getAllEmployee', data).catch((err) => { console.log(err) })
                .then(() => {
                    this.$vs.loading.close()
                }).catch(err => { 
                    this.$vs.loading.close()
                    console.error(err) 
                })
        
    },
    computed: {
        getAllCreateSchedule() {
            return this.$store.state.schedule.getAllCreateSchedule
        },
        getAllScheduleNumber() {
            return this.$store.state.lookup.getAllScheduleNumber
        },
        getAllTenant() {
            return this.$store.state.tenants.tenants
        },
        getAllTenantsSchedule() {
            return this.$store.getters['tenants/tenantsScheduleByNumber'](this.scheduleNumber.scheduleNumberId)
            // return this.$store.state.tenants.tenantsSchedule
        },
        getTenantName() {
            return (tenantId) => this.$store.getters['tenants/tenantName'](tenantId)
        },
        getStatusName() {
            return (value) => this.$store.getters['schedule/getStatusName'](value)
        },
        getSelectedEmployees() {
            return this.$store.state.scheduleSelectedEmployees
        },
        getScheduleNumberName() {
            return (scheduleNumberId) => this.$store.getters['lookup/getScheduleNumberName'](scheduleNumberId)
        },
        shiftTypeName() {
            return (shiftTypeId) => this.$store.getters['lookup/shiftTypeLookup'](shiftTypeId)
        },
        getDayName() {
            return (day) => this.$store.getters['lookup/getDayName'](day)
        },
        // getCreateScheduleStatusCountOpen() {
        //     return this.$store.getters['schedule/getCreateScheduleStatusCountOpen']()
        // },
        chipColor () {
            return (value) => {
                if(value > 0) {
                    if (value == 1) return 'success'
                    else if( value == 2 ) return 'warning'
                    else return 'danger'
                }
                else {
                    if (!value) return 'success'
                    else return 'danger'
                }
                    
                }
        },
    },
    methods: {
        validateStep1() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll('step-1').then(result => {
                    if (result) {
                        resolve(true)
                        const data = {
                            createScheduleId: this.createdSchedule.createScheduleId, 
                            userId: this.$store.state.AppActiveUser.uid 
                        }
                        this.$store.dispatch('hrms/getAllEmployeeScheduleByCreateScheduleId', data)
                            .then(() => {
                                this.isValidate2 = true
                            })
        
                        
                    }
                })
            })
        },
        validateStep2() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll('step-2').then(result => {
                    if (result) {
                        resolve(true)
                        this.isValidate2 = false
                        let timerInterval
                        Swal.fire({
                            title: 'Creating Schedule!!!',
                            html: '<b></b>',
                            timer: this.getSelectedEmployees.length * 100,
                            showConfirmButton: false,
                            didOpen: () => {
                                this.isValidate3 = false
                                this.onCreateSchedule()
                                const b = Swal.getHtmlContainer().querySelector('b')
                                timerInterval = setInterval(() => {
                                    b.textContent = 'Please wait while we create your employee schedules'
                                }, 100)
                                
                            },
                            }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                                Swal.fire('Create Schedule Successful', '', 'success' )
                            }
                        })
                        
                    }
                })
            })
        },
        validateStep3() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll('step-3').then(result => {
                    if (result) {
                        resolve(true)
                        Swal.fire({
                            title: "Do you want to proceed?",
                            text: 'Generated schedule will be posted',
                            icon: 'warning',
                            customClass: {
                                icon: "no-before-icon",
                            },
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, proceed!',
                            }).then((result) => {
                            if (result.isConfirmed) {
                                this.onSchedulePosted()
                            }
                        })
 
                    }
                })
            })
        },
        onCreateSchedule() {
            let user = []
            let e = this.getSelectedEmployees
            console.log(e)
            e.forEach((u) => {
                user.push(u.id)
            })
            const data= {
                createScheduleId: this.createdSchedule.createScheduleId,
                scheduleNumberId: this.scheduleNumber.scheduleNumberId,
                userId: user,//user.id,
                processedBy: this.$store.state.AppActiveUser.uid
            }
            axios.post('/api/schedule/generateschedule', data)
                .then(() => {
                    this.isValidate3 = true
                })
        },
        onSchedulePosted() {
            this.$vs.loading()
            axios.post('/api/schedule/postschedule', null, { params: {
                createScheduleId: this.createdSchedule.createScheduleId,
                processedBy: this.$store.state.AppActiveUser.uid 
            }})
                .then(() => {
                    this.$vs.loading.close()
                    this.$alert('Schedule has been posted', 'Done', 'success')
                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.$alert(error.message, 'Error', 'error')
                })
        },
        // onTempScheduleToLive() {
        //     this.$vs.loading()
        //     axios.post('/api/schedule/tempscheduletolive')
        //         .then(() => {
        //             this.$vs.loading.close()
        //             this.$alert('Schedule has been posted', 'Done', 'success')
        //         })
        //         .catch((error) => {
        //             this.$vs.loading.close()
        //             this.$alert(error.message, 'Error', 'error')
        //         })
        // },
        Save() {
            this.$validator.validateAll('step-1').then(result => {
                if (result) {
                    this.createdSchedule.tenantsId = this.tenant.tenantsId
                    this.createdSchedule.scheduleNumberId = this.scheduleNumber.scheduleNumberId
                    this.createdSchedule.cutOffStartDate = moment(this.createdSchedule.cutOffStartDate).format('YYYY-MM-DD')
                    this.createdSchedule.cutOffEndDate = moment(this.createdSchedule.cutOffEndDate).format('YYYY-MM-DD')
                    this.createdSchedule.referenceNumber = 'S' + moment().format('YYYYMMDD') + (this.getAllCreateSchedule.length + 1)
                    this.createdSchedule.status = 1
                    this.createdSchedule.isClosed = false
                    // this.createdSchedule.userId = this.$store.state.AppActiveUser.uid

                    const data = this.createdSchedule          
                    console.log(this.createdSchedule)
                    if(!this.checkIfOverlap(this.createdSchedule.cutOffStartDate, this.createdSchedule.cutOffEndDate, this.createdSchedule.scheduleNumberId)) return
                    this.$vs.loading()
                    // this.createdSchedule.tenantsId = tenant.tenantsId
                    this.$store.dispatch('schedule/addCreateSchedule', this.createdSchedule )
                        .then((response) => {
                            this.$vs.loading.close()
                            this.$alert('Save Successfully', 'Done', 'success')
                        })
                        .catch((error) => {
                            console.log(error.message)
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Error', 'error')
                        })
                }
                
            })
        },
        editRecord(id) {

        },
        confirmDelete(id) {

        },
        checkIfOverlap(f, t, id) {
            this.isOverlapped = false

            var f = moment(f).format("YYYY-MM-DD")
            var t = moment(t).format("YYYY-MM-DD")
            for(var x = 0; x < this.getAllCreateSchedule.length ; x++)
            {
                
                var date1 = moment(this.getAllCreateSchedule[x].cutOffStartDate).format('YYYY-MM-DD');
                var date2 = moment(this.getAllCreateSchedule[x].cutOffEndDate).format('YYYY-MM-DD');
           
                if ((date1 <= f && t <= date2) ||
                    (date1 >= f && t >= date2) ||
                    (date1 >= f && t >= date1) ||
                    (date2 >= f && t >= date2)) {
                        if (this.getAllCreateSchedule[x].createScheduleId != id)
                            this.isOverlapped = true
                    }
                


            }
            if(this.isOverlapped) {
                this.$alert('Date range is overlapped', 'Overlapped', 'error')
                return false
            }else
                return true
        },
        handleSelected(tr){
            const e = this.$store.getters['schedule/getCreateScheduleById'](tr.createScheduleId)
            this.scheduleNumber = this.getScheduleNumberName(e.scheduleNumberId)
            this.tenant = this.getTenantName(e.tenantsId)
            this.createdSchedule = e
            console.log(this.createdSchedule)
        }

    },
    components: {
        FormWizard,
        TabContent,
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        Swal,
        SelectEmployees,
        VerifySchedule,
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
// @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>